<template>
	<b-container class='report-page'>
        <b-row>
                <b-col sm="3">
                    <b-form-group>
                        <label>{{ $t('travel_time_report.line') }}</label>
                        <vSelect :options="lineOptions" v-model="selectedLine" />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label>{{ $t('travel_time_report.route') }}</label>
                        <vSelect :options="routeOptions" v-model="selectedRoute" :reduce="route => route.routeId" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('travel_time_report.daytype') }}</label>
                        <vSelect :options="dayTypeOptions" v-model="selectedDaytype" label="description" :reduce="dayType => dayType.dayTypeId" />
                    </b-form-group>
                </b-col>
               
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('travel_time_report.stop1') }}</label>
                        <vSelect :options="stop1Options" v-model="selectedStop1" label="nimi" :reduce="stop => stop.tunnus" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('travel_time_report.stop2') }}</label>
                        <vSelect :options="stop2Options" v-model="selectedStop2" label="nimi" :reduce="stop => stop.tunnus" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('travel_time_report.start_date') }}</label>
                        <b-form-datepicker 
                            :placeholder="this.$t('datepicker.labelNoDateSelected')"
                            v-model="selectedStartDate" 
                            :locale="this.$t('datepicker.locale')" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }" >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('travel_time_report.end_date') }}</label>
                        <b-form-datepicker 
                            :placeholder="this.$t('datepicker.labelNoDateSelected')"
                            v-model="selectedEndDate" 
                            :locale="this.$t('datepicker.locale')" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }" >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class='btn-row'>
                <b-col>
                    <b-button class="btn-success btn-report" @click="generateReport()" :disabled="buttonDisabled">
                        <b-icon icon="arrow-clockwise" scale="1.2"></b-icon>
                        {{ $t('report.generate') }}
                    </b-button>
                    <b-button class="btn-success btn-report" @click="printReport()" :disabled="buttonDisabled || !generated">
                        <b-icon icon="printer" scale="1.2"></b-icon>
                        {{ $t('report.print') }}
                    </b-button>
                    <b-button class="btn-success btn-report" @click="generateXLS()" :disabled="buttonDisabled || !generated">
                        <b-icon icon="download" scale="1.2"></b-icon>
                        {{ $t('report.download') }}
                    </b-button>
                </b-col>  
            </b-row>
            

			<b-row>
				<b-col>
                    <b-table
						striped
						:items="items"
						:fields="fields"
						:per-page="perPage"
						:current-page="currentPage"
                        :busy="loading">
                        <template #table-busy>
                            <Loading />
                        </template>
                    </b-table>

					<TablePagination
						:total-rows="totalRows"
						:per-page="perPage"
						@pageChange="onPageChange"
					>
					</TablePagination>
				</b-col>
			</b-row>
	</b-container>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination';
//import punctualityReport from '@/store/realtime/punctualityReport';
import travelTimeReport from '@/store/realtime/travelTimeReport';
import vSelect from 'vue-select'
import moment from 'moment';

export default {
	components: { TablePagination, vSelect },
	data: function() {
		return {
			perPage: 30,
			currentPage: 1,
			filteredRows: 0,
            //availableStops: [],
            selectedLine: null,
            selectedRoute: null,
            selectedStop1: null,
            selectedStop2: null,
            selectedStartDate: new moment().format('YYYY-MM-DD'),
            selectedEndDate: new moment().format('YYYY-MM-DD'),
            selectedDaytype: null,
            loading: false,
            generated: false,
            printing : false
		};
	},
	computed: {
		fields() {
            return [
                { key: 'hour', label: this.$t('travel_time_report.hour'), sortable: true,
                    formatter: function(value) {
                        return String(value).padStart(2, '0') +'-'+ String(value + 1).padStart(2, '0')
                    }
                },
				{ key: 'scheduledTime', label: this.$t('travel_time_report.scheduled_time'), sortable: true, formatter: 'formatDuration' },
				{ key: 'actualTime', label: this.$t('travel_time_report.actual_time'), formatter: 'formatDuration' },
				{ key: 'deviation', label: this.$t('travel_time_report.deviation'), formatter: 'formatDeviation' },
            ];
        },
		items() {
			return this.$store.state.travelTimeReport.travelTimeReportList;
		},
        lineOptions() {
            //return this.$store.state.punctualityReport.availableLineNumbers;
            var lines = [];
            for (var line in this.$store.state.travelTimeReport.linesWithRoutes) {
                lines.push(line);
            }
            return lines;
        },
        routeOptions() {
            var routes = [];
            if (this.selectedLine && this.$store.state.travelTimeReport.linesWithRoutes[this.selectedLine]) {
                //return this.$store.state.travelTimeReport.linesWithRoutes[this.selectedLine];
                for (var route of this.$store.state.travelTimeReport.linesWithRoutes[this.selectedLine]) {
                    // routes.push({ routeId: route.routeId, label: route.routeId +' '+ route.destination });
                    routes.push({ routeId: route.routeId, label: route.name });
                }
            }
			routes.sort( (a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0) );

            return routes;
        },
        stop1Options() {
            if (this.selectedRoute) {
                return this.$store.state.travelTimeReport.currentStopList;
            }
            return [];
        },
        stop2Options() {
            var stops = [];
            if (this.selectedStop1) {
                var startFound = false;
                for (let stop of this.$store.state.travelTimeReport.currentStopList) {
                    if (startFound) {
                        stops.push(stop);
                    } else if (stop.tunnus == this.selectedStop1) {
                        startFound = true;
                    }
                }
            }
            return stops;
        },
        dayTypeOptions() {
            var dayTypes = [];
            for (let dayType of this.$store.state.travelTimeReport.dayTypes) {
                var desc = "";
                for (var i in dayType.weekDays) {
                    var wd = this.$t('weekdays.'+ dayType.weekDays[i].toLowerCase());
                    desc += !wd.startsWith('weekdays') ? wd : dayType.weekDays[i];
                    if (i < dayType.weekDays.length - 1) {
                        desc += ',';
                    }
                }
                var dt = {
                    dayTypeId: dayType.dayTypeId,
                    description: desc
                };
                dayTypes.push(dt);
            }
            return dayTypes.sort(function(x, y) {
                if (x.dayTypeId < y.dayTypeId) {
                    return -1;
                }
                if (x.dayTypeId > y.dayTypeId) {
                    return 1;
                }
                return 0;
            });
        },
        buttonDisabled() {
            return !this.selectedRoute || !this.selectedStop1 || !this.selectedStop2 ||
                !this.selectedStartDate || !this.selectedEndDate || !this.selectedDaytype || this.loading || this.printing;
        },
		totalRows() {
			return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
		},
	},
    watch: {
        selectedLine() {
            this.selectedStop2 = null;
            this.selectedStop1 = null;
            this.selectedRoute = null;
        },
        selectedRoute() {
            this.selectedStop2 = null;
            this.selectedStop1 = null;
            if (this.selectedRoute) {
                this.$store.dispatch('travelTimeReport/getRouteStops', this.selectedRoute);
            } else {
                this.$store.commit('travelTimeReport/updateCurrentStopList', []);
            }
        },
        selectedStop1() {
            this.selectedStop2 = null;
        }
    },
    beforeCreate() {
		if (!this.$store.state.travelTimeReport) {
            this.$store.registerModule("travelTimeReport", travelTimeReport);
        }
        this.$store.dispatch('travelTimeReport/getLinesWithRoutes');
        this.$store.dispatch('travelTimeReport/getDayTypes');
    },
    created(){
        window.addEventListener("afterprint", this.afterprint);
    },
    beforeDestroy(){
        window.removeEventListener("afterprint", this.afterprint);
    },
	methods: {
		onFiltered(filteredItems) {
			this.filteredRows = filteredItems.length;
			this.currentPage = 1;
		},
		onPageChange(page) {
			this.currentPage = page;
		},
        generateReport() {
            this.loading = true;

            var startTime = new moment(this.selectedStartDate, 'YYYY-MM-DD');
            var endTime = new moment(this.selectedEndDate, 'YYYY-MM-DD');
            var params = {
                'route': this.selectedRoute,
                'stop1': this.selectedStop1,
                'stop2': this.selectedStop2,
                'startDate': startTime.format('YYYY-MM-DD[T00:00:00]ZZ'),
                'endDate': endTime.format('YYYY-MM-DD[T23:59:59]ZZ'),
                'dayType': this.selectedDaytype
            }
            this.$store.dispatch('travelTimeReport/getTravelTimeReportList', params)
                .finally(() => { this.loading = false; this.generated = true });
        },
        generateXLS() {
            this.loading = true;

            var startTime = new moment(this.selectedStartDate, 'YYYY-MM-DD');
            var endTime = new moment(this.selectedEndDate, 'YYYY-MM-DD');
            var dayTypeText = '';
            for (let dayType of this.$store.state.travelTimeReport.dayTypes) {
                if (dayType.dayTypeId == this.selectedDaytype) {
                    for (var i in dayType.weekDays) {
                        var wd = this.$t('weekdays.'+ dayType.weekDays[i].toLowerCase());
                        dayTypeText += !wd.startsWith('weekdays') ? wd : dayType.weekDays[i];
                        if (i < dayType.weekDays.length - 1) {
                            dayTypeText += ',';
                        }
                    }
                    break;
                }
            }
            var params = {
                'route': this.selectedRoute,
                'stop1': this.selectedStop1,
                'stop2': this.selectedStop2,
                'startDate': startTime.format('YYYY-MM-DD[T00:00:00]ZZ'),
                'endDate': endTime.format('YYYY-MM-DD[T23:59:59]ZZ'),
                'dayType': this.selectedDaytype,
                'header1': this.$t('travel_time_report.hour'),
                'header2': this.$t('travel_time_report.scheduled_time'),
                'header3': this.$t('travel_time_report.actual_time'),
                'header4': this.$t('travel_time_report.deviation'),
                'line': this.selectedLine,
                'header5': this.$t('travel_time_report.line'),
                'header6': this.$t('travel_time_report.route'),
                'header7': this.$t('travel_time_report.stop1'),
                'header8': this.$t('travel_time_report.stop2'),
                'header9': this.$t('travel_time_report.start_date'),
                'header10': this.$t('travel_time_report.end_date'),
                'header11': this.$t('travel_time_report.daytype'),
                'dayTypeText': dayTypeText
            }
            this.$store.dispatch('travelTimeReport/exportXLS', params)
                .finally(() => { this.loading = false; });
        },
        formatDuration(duration) {
            if (!duration) return '';
            if (duration >= 3600000) {
                return new moment.utc(duration).format('HH:mm:ss');
            }
            if (duration >= 0) {
                return new moment.utc(duration).format('mm:ss');
            }
            if (duration <= -3600000) {
                return new moment.utc(Math.abs(duration)).format('[-]HH:mm:ss');
            }
            return new moment.utc(Math.abs(duration)).format('[-]mm:ss');
        },
        formatDeviation(deviation) {
            if (!deviation) return '';
            if (deviation >= 3600000) {
                return new moment.utc(deviation).format('[+]HH:mm:ss');
            }
            if (deviation >= 0) {
                return new moment.utc(deviation).format('[+]mm:ss');
            }
            if (deviation <= -3600000) {
                return new moment.utc(Math.abs(deviation)).format('[-]HH:mm:ss');
            }
            return new moment.utc(Math.abs(deviation)).format('[-]mm:ss');
        },
        printReport(){
            this.printing = true;
            this.perPage = this.items.length
            
            // timeout needed because table takes some time to render
            setTimeout(() => { window.print(); }, 10);   
        },
        afterprint(){
            this.perPage = 30;
            this.printing = false;
        }
	}
};
</script>